import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import ApprovalStatus from "../components/ApprovalStatus";
import FinalBilling from "../components/FinalBilling";
import DischargeSummary from "../components/DischargeSummary";
import FinalizeButton from "../components/FinalizeButton";

const DischargeWorkflow = () => {
  const navigate = useNavigate();

  const [approvals, setApprovals] = useState([
    {
      initials: "DR",
      name: "Deepak Rupani",
      role: "PO Approver Level 1 (Buyer)",
      timestamp: "2024-12-11T08:30:00Z",
      status: "Approved",
      comment: "The PO looks good. Approved without any issues.",
    },
    {
      initials: "AB",
      name: "Anjali Bhatt",
      role: "PO Approver Level 2",
      timestamp: "2024-12-11T10:15:00Z",
      status: "Pending",
      comment: "Need clarification on the budget allocation.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
    {
      initials: "RK",
      name: "Ravi Kumar",
      role: "PO Approver Level 3",
      timestamp: "2024-12-11T09:45:00Z",
      status: "Rejected",
      comment: "The vendor pricing does not align with our standards.",
    },
  ]);

  const [isDischarged, setIsDischarged] = useState(false);

  const currentUser = {
    initials: "AB",
    name: "Anjali Bhatt",
  };

  const patient = {
    id: "PAT001",
    name: "Ramesh Kumar",
    age: 45,
    gender: "Male",
    contact: "9876543210",
    address: "123 Main Street, New Delhi, India",
    emergencyContact: "Rajesh Kumar - 9876543211",
    admissionDate: "2023-11-01",
    doctor: "Dr. Singh",
    ward: "Ward 101",
    bed: "Bed 12",
    diagnosis: "Acute Appendicitis",
    treatmentSummary: "Appendectomy surgery performed successfully.",
    medications: ["Paracetamol", "Amoxicillin"],
    followUpInstructions: "Follow-up after 7 days. Monitor any abdominal pain.",
    billing: {
      items: [
        { description: "Consultation Fee", amount: 500, paid: true },
        { description: "Lab Tests", amount: 1200, paid: false },
        { description: "Room Charges", amount: 3000, paid: true },
        { description: "Medication", amount: 800, paid: false },
      ],
      total: 5500,
      paid: 3500,
      due: 2000,
    },
  };

  const handleFinalizeDischarge = () => {
    const updatedApprovals = approvals.map((approval) =>
      Math.random() > 0.5
        ? { ...approval, status: "Approved" }
        : { ...approval, status: "Pending" }
    );
    setApprovals(updatedApprovals);

    const allApproved = updatedApprovals.every(
      (approval) => approval.status === "Approved"
    );

    if (allApproved) {
      setIsDischarged(true);
      alert("Discharge process successfully completed!");
      navigate(-1);
    } else {
      alert("Some approvals are still pending. Please check again.");
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen space-y-6">
      <Header patient={patient} onBack={() => navigate(-1)} />
      <ApprovalStatus approvals={approvals} currentUser={currentUser} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <FinalBilling patient={patient} />
        <DischargeSummary patient={patient} />
      </div>
      <FinalizeButton onFinalize={handleFinalizeDischarge} />
    </div>
  );
};

export default DischargeWorkflow;
